export class ModalidadPrestacion {
	id: 'CCE' | 'NOE' | 'LAN' | 'EXC' | 'REC' | 'CCN' | 'MUL';
	descripcion: string;

	constructor(data = null) {
		if (data) {
			this.id = data.id;
			this.descripcion = data.descripcion;
		}
	}
}
